import _import from './config'
export default {
    path: 'personage',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'personage',
    redirect: '/personage/info',
    children:[
        {
            path:'info',
            component: _import('personage/info'),
            name: 'info',
            meta: {
                auth: true,
            }
        },{
            path: 'index',
            component: _import('workbench/userInfo'),
            name: 'index',
            meta: {
                auth: true,
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/user.js